import { createSlice } from '@reduxjs/toolkit'

export const ProjectRequestReferenceDocumentSlice = createSlice({
  name: 'project_request_reference_material',
  initialState: {
    value: [],
  },
  reducers: {
    projectRequestReferenceDocument: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { projectRequestReferenceDocument } = ProjectRequestReferenceDocumentSlice.actions

export default ProjectRequestReferenceDocumentSlice.reducer